import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DefaultBrandLogo from '../ui/default-brand-logo';


interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export function SidebarHeader({ isCollapsed, onToggle }: SidebarHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const companyName = 'Релевантер';
  const isAtsRoute = location.pathname === '/ats' || location.pathname.startsWith('/ats/');

  if (isCollapsed) return null;

  const handleLogoClick = () => {
    navigate(isAtsRoute ? '/ats' : '/recruiter/vacancy');
  };

  return (
    <div data-testid="sidebar-header" className="flex items-center gap-2.5 px-5 py-4 border-b border-sidebar-border h-[57px] box-border">
      <div
        data-testid="sidebar-logo-link"
        onClick={handleLogoClick}
        className="flex items-center gap-2.5 cursor-pointer hover:opacity-80 transition-opacity"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleLogoClick();
          }
        }}
      >
        {isAtsRoute ? (
          <span data-testid="sidebar-logo" className="text-[20px] font-semibold whitespace-nowrap text-[var(--text-dark)]">
            Talant Bank
          </span>
        ) : (
          <>
            <DefaultBrandLogo size={24} />
            <span data-testid="sidebar-logo" className="text-[16px] font-medium text-[var(--text-dark)]">
              {companyName}
            </span>
          </>
        )}
      </div>
      <button
        data-testid="sidebar-collapse-toggle"
        className="ml-auto hover:opacity-70 transition-opacity"
        onClick={onToggle}
        aria-label="Свернуть сайдбар"
      >
        <img src="/icons/sidebar_icon.png" alt="collapse" width="16" height="16" />
      </button>
    </div>
  );
}
